"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPrepPackagingType = exports.ProductPrepCategory = void 0;
var ProductPrepCategory;
(function (ProductPrepCategory) {
    ProductPrepCategory["ADULT"] = "ADULT";
    ProductPrepCategory["APPAREL_FABRIC_PLUSH_TEXTILES"] = "APPAREL_FABRIC_PLUSH_TEXTILES";
    ProductPrepCategory["BABY"] = "BABY";
    ProductPrepCategory["FRAGILE_GLASS"] = "FRAGILE_GLASS";
    ProductPrepCategory["NON_GLASS_LIQUIDS"] = "NON_GLASS_LIQUIDS";
    ProductPrepCategory["OTHER"] = "OTHER";
    ProductPrepCategory["PERFORATED_PACKAGING"] = "PERFORATED_PACKAGING";
    ProductPrepCategory["POWDER_PELLETS_GRANULAR"] = "POWDER_PELLETS_GRANULAR";
    ProductPrepCategory["SHARP"] = "SHARP";
    ProductPrepCategory["SMALL"] = "SMALL";
})(ProductPrepCategory = exports.ProductPrepCategory || (exports.ProductPrepCategory = {}));
var ProductPrepPackagingType;
(function (ProductPrepPackagingType) {
    ProductPrepPackagingType["ADULT"] = "ADULT";
    ProductPrepPackagingType["BUBBLE_WRAP"] = "BUBBLE_WRAP";
    ProductPrepPackagingType["LIQUID"] = "LIQUID";
    ProductPrepPackagingType["NONE"] = "NONE";
    ProductPrepPackagingType["POLY_BAG"] = "POLY_BAG";
})(ProductPrepPackagingType = exports.ProductPrepPackagingType || (exports.ProductPrepPackagingType = {}));
//# sourceMappingURL=ProductPreparation.js.map